module.exports = __webpack_public_path__ + "img/surveyEmoji3.422f7756.svg";